import { render, staticRenderFns } from "./XinguanOrderList.vue?vue&type=template&id=f8cbb1ce&scoped=true&"
import script from "./XinguanOrderList.vue?vue&type=script&lang=js&"
export * from "./XinguanOrderList.vue?vue&type=script&lang=js&"
import style0 from "./XinguanOrderList.vue?vue&type=style&index=0&id=f8cbb1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cbb1ce",
  null
  
)

export default component.exports